import React from 'react';
import { connect } from 'react-redux';
import { yaxis_double } from '../../../../constants';
import { arrayIsNotEmpty, getPercentage, getXaxisCategories, isDefined } from '../../../../utils';
import GeneralChart from "./GeneralChart.jsx";

class ResponsesChartContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notVisibleAggregationName: []
        };
        this.toggleDataSeries = this.toggleDataSeries.bind(this);
    }

    toggleDataSeries(e) {
        if (this.state.notVisibleAggregationName.includes(e.dataSeries.name)) {
            this.state.notVisibleAggregationName = this.state.notVisibleAggregationName.filter(item => item !== e.dataSeries.name);
        }
        else {
            this.state.notVisibleAggregationName.push(e.dataSeries.name);
        }

        this.setState({ reactUpdater: !this.state.reactUpdater });
    }

    render() {
        const { responselBreakdownOverTimeStats, questionCode } = this.props;

        if (!responselBreakdownOverTimeStats || !Array.isArray(responselBreakdownOverTimeStats)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }
        else if (responselBreakdownOverTimeStats.length == 0) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                No data for the selected filters
            </div>;
        }

        let data = [];

        const responseData = responselBreakdownOverTimeStats.filter(p => p.questionCode === questionCode);

        const emptyDataPoint = [{
            label: 0,
            y: undefined
        }];

        const hybridCountDataPoints = this.state.notVisibleAggregationName.includes('Hybrid Count')
            ? emptyDataPoint
            : responseData.map(t => {
                return {
                    label: t.windowStart.slice(0, 5),
                    y: t.sumQuestionEffectiveResponses
                }
            });

        const hybridCountData = {
            type: "column",
            axisYType: "secondary",
            color: '#49CB85',
            name: 'Hybrid Count',
            showInLegend: true,
            yValueFormatString: "#,###",
            dataPoints: hybridCountDataPoints
        };
        data.push(hybridCountData);

        //Customer Count
        const customerCountDataPoints = this.state.notVisibleAggregationName.includes('Customer Count')
            ? emptyDataPoint
            : responseData.map(t => {
                return {
                    label: t.windowStart.slice(0, 5),
                    y: t.sumCustomerResponses
                }
            });

        const customerCountData = {
            type: "column",
            axisYType: "secondary",
            color: '#935AD8',
            name: 'Customer Count',
            showInLegend: true,
            yValueFormatString: "#,###",
            dataPoints: customerCountDataPoints
        };
        data.push(customerCountData);

        //Agent Response
        const maxDateIndex = responseData.reduce((max, obj) => {
            return obj.dateIndex > max ? obj.dateIndex : max;
        }, -Infinity);

        let hybridResponseDataPoints = [];
        if (this.state.notVisibleAggregationName.includes('Hybrid %')) {
            hybridResponseDataPoints = emptyDataPoint;
        }
        else {
            for (let i = 1; i <= maxDateIndex; i++) {
                if (questionCode === 'NPS') {
                    const valuesInDate = responseData.filter(rd => rd.dateIndex === i);
                    if (arrayIsNotEmpty(valuesInDate)) {
                        // Calculate the sum of all counts
                        const totalEffectiveResponseCntRounded = valuesInDate.reduce((sum, item) => sum + (item.effectiveResponseCntRounded || 0), 0);
                        const promoter = valuesInDate.find(v => v.finalResponse === 'Promoter');
                        const detractor = valuesInDate.find(v => v.finalResponse === 'Detractor');
                        const promoterPercentage = isDefined(promoter) ? getPercentage(promoter.effectiveResponseCntRounded, totalEffectiveResponseCntRounded) : 0;
                        const detractorPercentage = isDefined(detractor) ? getPercentage(detractor.effectiveResponseCntRounded, totalEffectiveResponseCntRounded) : 0;

                        if (isDefined(promoterPercentage) && isDefined(detractorPercentage)) {
                            hybridResponseDataPoints.push({
                                label: valuesInDate[0].windowStart.slice(0, 5),
                                y: promoterPercentage - detractorPercentage
                            });
                        }
                    }
                } else {
                    const valuesInDate = responseData.filter(rd => rd.dateIndex === i);
                    if (arrayIsNotEmpty(valuesInDate)) {
                        // Calculate the sum of all counts
                        const totalEffectiveResponseCntRounded = valuesInDate.reduce((sum, item) => sum + (item.effectiveResponseCntRounded || 0), 0);
                        const positive = valuesInDate.find(p => (p.finalResponse === 'Yes' || p.finalResponse === 'Satisfied'));

                        if (isDefined(positive)) {
                            hybridResponseDataPoints.push({
                                label: positive.windowStart.slice(0, 5),
                                y: getPercentage(positive.effectiveResponseCntRounded, totalEffectiveResponseCntRounded)
                            });
                        }
                    }
                }
            }
        }

        const hybridResponseData = {
            type: "spline",
            color: '#49CB85',
            name: 'Hybrid %',
            yAxis: 1,
            showInLegend: true,
            yValueFormatString: "#,###",
            dataPoints: hybridResponseDataPoints
        };
        data.push(hybridResponseData);

        //Customer Response
        const customerResponseDataPoints = [];
        if (this.state.notVisibleAggregationName.includes('Customer %')) {
            customerResponseDataPoints = emptyDataPoint;
        } else {
            for (let i = 1; i <= maxDateIndex; i++) {
                if (questionCode === 'NPS') {
                    const valuesInDate = responseData.filter(rd => rd.dateIndex === i);
                    if (arrayIsNotEmpty(valuesInDate)) {
                        // Calculate the sum of all counts
                        const totalEffectiveResponseCntRounded = valuesInDate.reduce((sum, item) => sum + (item.customerResponseCnt || 0), 0);
                        const promoter = valuesInDate.find(v => v.finalResponse === 'Promoter');
                        const detractor = valuesInDate.find(v => v.finalResponse === 'Detractor');
                        const promoterPercentage = isDefined(promoter) ? getPercentage(promoter.customerResponseCnt, totalEffectiveResponseCntRounded) : 0;
                        const detractorPercentage = isDefined(detractor) ? getPercentage(detractor.customerResponseCnt, totalEffectiveResponseCntRounded) : 0;

                        if (isDefined(promoterPercentage) && isDefined(detractorPercentage)) {
                            customerResponseDataPoints.push({
                                label: valuesInDate[0].windowStart.slice(0, 5),
                                y: promoterPercentage - detractorPercentage
                            });
                        }
                    }
                } else {
                    const valuesInDate2 = responseData.filter(rd => rd.dateIndex === i);
                    if (arrayIsNotEmpty(valuesInDate2)) {
                        // Calculate the sum of all counts
                        const totalEffectiveResponseCntRounded2 = valuesInDate2.reduce((sum, item) => sum + (item.customerResponseCnt || 0), 0);
                        const positive = valuesInDate2.find(p => (p.finalResponse === 'Yes' || p.finalResponse === 'Satisfied'));

                        if (isDefined(positive)) {
                            customerResponseDataPoints.push({
                                label: positive.windowStart.slice(0, 5),
                                y: getPercentage(positive.customerResponseCnt, totalEffectiveResponseCntRounded2)
                            });
                        }
                    }
                }
            }
        }

        const customerResponseData = {
            type: "spline",
            color: '#935AD8',
            name: 'Customer %',
            yAxis: 1,
            showInLegend: true,
            yValueFormatString: "#,###",
            dataPoints: customerResponseDataPoints
        };
        data.push(customerResponseData);

        return (
            <>
                <GeneralChart
                    yAxis={yaxis_double}
                    series={data}
                    showLegends={true}
                    xAxisCategories={[...getXaxisCategories(data)]}
                />
            </>
        );
    }
}

const select = state => ({});

export default connect(select)(ResponsesChartContainer);